import { VStack, Text, HStack } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { useFormContext, useWatch } from 'react-hook-form'
import IconBuilder from 'pages/IconBuilderPage/components/IconBuilder'
import { getValidArray } from 'utils/common'
import { BlockTextFormValues } from '../../enums'
const IconSection = () => {
  const { setValue, control } = useFormContext()
  const { iconBuilderStore } = useStores()
  const { blockIcons } = iconBuilderStore
  const iconId: number = useWatch({ control, name: BlockTextFormValues.ICON_ID }) || null
  return (
    <VStack alignItems="flex-start" spacing={2} paddingY={4}>
      <Text fontWeight="500" fontSize="16px" lineHeight="24px" color="gray.700" marginBottom={0}>
        Instruction Icon
      </Text>
      <HStack spacing={0} gap={3} width="full" flexWrap="wrap">
        {getValidArray(blockIcons).map(icon => {
          return (
            <IconBuilder
              key={`icon-preview-${icon?.id}`}
              icon={icon}
              size={40}
              isActive={Number(iconId) === Number(icon?.id)}
              onClick={() => setValue(BlockTextFormValues.ICON_ID, icon.id)}
            />
          )
        })}
      </HStack>
    </VStack>
  )
}

export default observer(IconSection)
